import { useDispatch, useSelector } from "react-redux";
import { updateCustomerDetail } from "../../redux/slices/customerSlice";

const CustomerDetailForm = ({ uneditable = false }) => {
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.customer);

  const handleChange = (e) => {
    if (uneditable) return;

    let value = e.target.value;

    // Normalisasi nomor HP: ubah +62 menjadi 08
    if (e.target.name === "phone") {
      value = value.replace(/^\+62/, "0");
      // Jika dimulai dengan 62 (tanpa +), ubah jadi 08
      if (value.startsWith("62") && !value.startsWith("0")) {
        value = "0" + value.substring(2);
      }
    }

    dispatch(updateCustomerDetail({ [e.target.name]: value }));
  };

  const inputClass = `w-full border rounded-md p-2 ${uneditable ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`;

  return (
    <form className="space-y-4">
      <div>
        <label className="block text-gray-700">Full Name</label>
        <input
          type="text"
          name="fullName"
          value={customer.fullName}
          onChange={handleChange}
          readOnly={uneditable}
          required
          className={inputClass}
          placeholder="john doe"
        />
      </div>
      <div>
        <label className="block text-gray-700">Phone</label>
        <input
          type="tel"
          name="phone"
          value={customer.phone}
          onChange={handleChange}
          readOnly={uneditable}
          required
          className={inputClass}
          placeholder="08xxxxxxxxxx"
        />
        <p className="text-xs text-gray-500 mt-1">Nomor ini akan menerima notifikasi invoice dan pembayaran</p>
      </div>
      <div>
        <label className="block text-gray-700">Email</label>
        <input
          type="email"
          name="email"
          value={customer.email}
          onChange={handleChange}
          readOnly={uneditable}
          required
          className={inputClass}
          placeholder="johndoe@gmail.com"
        />
        <p className="text-xs text-gray-500 mt-1">Email ini akan menerima notifikasi invoice dan pembayaran</p>
      </div>
    </form>
  );
};

export default CustomerDetailForm;
